import { useState, useEffect } from 'react'
import { ALERGENOS_LIST } from '../data/carta'
import axios from 'axios'
import './AdminCarta.css'

const API = process.env.REACT_APP_API_URL || ''

const TABS = [
  { id: 'entrantes', label: 'Entrantes' },
  { id: 'principales', label: 'Principales' },
  { id: 'postres', label: 'Postres' },
  { id: 'bebidas', label: 'Bebidas' },
]

const CARTA_VACIA = { entrantes: [], principales: [], postres: [], bebidas: [] }
const PLATO_VACIO = { nombre: '', desc: '', precio: '', alergenos: [] }

export default function AdminCarta() {
  const [carta, setCarta] = useState(CARTA_VACIA)
  const [tab, setTab] = useState('entrantes')
  const [modal, setModal] = useState(null)
  const [form, setForm] = useState(PLATO_VACIO)
  const [guardando, setGuardando] = useState(false)
  const [mensaje, setMensaje] = useState('')
  const [error, setError] = useState('')
  const [cargando, setCargando] = useState(true)

  const token = () => localStorage.getItem('token')
  const headers = () => ({ Authorization: `Bearer ${token()}` })

  const cargarCarta = () => {
    setCargando(true)
    axios.get(`${API}/api/carta/admin`, { headers: headers() })
      .then(res => setCarta(res.data))
      .catch(() => setError('No se pudo cargar la carta.'))
      .finally(() => setCargando(false))
  }

  useEffect(() => { cargarCarta() }, [])

  const mostrarMensaje = (txt) => {
    setMensaje(txt)
    setTimeout(() => setMensaje(''), 2500)
  }

  const abrirNuevo = () => {
    setForm({ ...PLATO_VACIO })
    setModal('nuevo')
  }

  const abrirEditar = (plato) => {
    setForm({
      id: plato.id,
      nombre: plato.nombre,
      desc: plato.desc,
      precio: plato.precio,
      alergenos: plato.alergenos || [],
    })
    setModal('editar')
  }

  const cerrarModal = () => { setModal(null); setForm(PLATO_VACIO); setError('') }

  const toggleAlergeno = (id) => {
    const ya = form.alergenos.includes(id)
    setForm({ ...form, alergenos: ya ? form.alergenos.filter(a => a !== id) : [...form.alergenos, id] })
  }

  const guardarPlato = async () => {
    if (!form.nombre.trim() || !form.precio) {
      setError('Nombre y precio son obligatorios.')
      return
    }
    setGuardando(true)
    setError('')
    try {
      if (modal === 'nuevo') {
        await axios.post(`${API}/api/carta/`, { ...form, categoria: tab }, { headers: headers() })
        mostrarMensaje('Plato creado correctamente')
      } else {
        await axios.put(`${API}/api/carta/${form.id}`, form, { headers: headers() })
        mostrarMensaje('Plato actualizado correctamente')
      }
      cargarCarta()
      cerrarModal()
    } catch (err) {
      setError(err.response?.data?.error || 'Error al guardar el plato.')
    } finally {
      setGuardando(false)
    }
  }

  const eliminarPlato = async (id) => {
    if (!window.confirm('¿Eliminar este plato?')) return
    try {
      await axios.delete(`${API}/api/carta/${id}`, { headers: headers() })
      mostrarMensaje('Plato eliminado')
      cargarCarta()
    } catch {
      setError('No se pudo eliminar el plato.')
    }
  }

  if (cargando) return <div className="loading">Cargando carta...</div>

  return (
    <div className="page">
      <div className="page-header">
        <p className="page-label">Panel de administracion</p>
        <h1 className="page-title">Gestionar Carta</h1>
        <div className="page-divider"></div>
        {mensaje && <p style={{ color: '#2ecc71', fontSize: '0.75rem' }}>{mensaje}</p>}
        {error && !modal && <p style={{ color: '#e74c3c', fontSize: '0.75rem' }}>{error}</p>}
      </div>

      <div className="admin-carta-header">
        <div className="carta-tabs" style={{ margin: 0 }}>
          {TABS.map(t => (
            <button key={t.id} className={`carta-tab ${tab === t.id ? 'active' : ''}`} onClick={() => setTab(t.id)}>
              {t.label}
            </button>
          ))}
        </div>
        <button className="btn-primary" style={{ width: 'auto', padding: '0.8rem 2rem' }} onClick={abrirNuevo}>
          + Nuevo plato
        </button>
      </div>

      <div className="admin-carta-lista">
        {(carta[tab] || []).length === 0 ? (
          <div className="empty-state">No hay platos en esta categoría</div>
        ) : (carta[tab] || []).map(plato => (
          <div key={plato.id} className="admin-plato-fila">
            <div className="admin-plato-info">
              <div className="admin-plato-nombre">{plato.nombre}</div>
              <div className="admin-plato-desc">{plato.desc}</div>
              <div className="admin-plato-alergenos">
                {(plato.alergenos || []).map(aid => {
                  const a = ALERGENOS_LIST.find(x => x.id === aid)
                  return a ? <span key={aid} className="alergeno-badge" title={a.nombre}>{a.icono}</span> : null
                })}
              </div>
            </div>
            <div className="admin-plato-precio">{plato.precio}€</div>
            <div className="admin-plato-acciones">
              <button className="btn-secondary" style={{ fontSize: '0.6rem', padding: '0.4rem 0.8rem' }} onClick={() => abrirEditar(plato)}>Editar</button>
              <button className="btn-danger" style={{ fontSize: '0.6rem', padding: '0.4rem 0.8rem' }} onClick={() => eliminarPlato(plato.id)}>Eliminar</button>
            </div>
          </div>
        ))}
      </div>

      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200, backdropFilter: 'blur(4px)', padding: '1rem' }} onClick={cerrarModal}>
          <div style={{ background: '#1A1714', border: '1px solid rgba(201,168,76,0.2)', padding: '2.5rem', maxWidth: '540px', width: '100%', position: 'relative', maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
            <button onClick={cerrarModal} style={{ position: 'absolute', top: '1rem', right: '1rem', background: 'none', border: 'none', cursor: 'pointer', color: '#A89880', fontSize: '1rem' }}>✕</button>
            <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.5rem', fontWeight: 300, marginBottom: '2rem' }}>
              {modal === 'nuevo' ? 'Nuevo plato' : 'Editar plato'}
            </h2>

            {error && <div className="error-msg" style={{ marginBottom: '1rem' }}>{error}</div>}

            <div className="form-group">
              <label>Nombre del plato</label>
              <input type="text" value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} placeholder="Nombre" />
            </div>
            <div className="form-group">
              <label>Descripcion</label>
              <textarea value={form.desc} onChange={e => setForm({ ...form, desc: e.target.value })} placeholder="Descripcion del plato" style={{ height: '60px' }} />
            </div>
            <div className="form-group">
              <label>Precio (€)</label>
              <input type="number" step="0.01" min="0" value={form.precio} onChange={e => setForm({ ...form, precio: e.target.value })} placeholder="0.00" />
            </div>
            <div className="form-group">
              <label style={{ marginBottom: '1rem', display: 'block' }}>Alergenos</label>
              <div className="alergenos-selector">
                {ALERGENOS_LIST.map(a => (
                  <button
                    key={a.id}
                    type="button"
                    className={`alergeno-selector-btn ${form.alergenos.includes(a.id) ? 'selected' : ''}`}
                    onClick={() => toggleAlergeno(a.id)}
                    title={a.nombre}
                  >
                    <span>{a.icono}</span>
                    <span>{a.nombre}</span>
                  </button>
                ))}
              </div>
            </div>
            <div style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem' }}>
              <button onClick={cerrarModal} style={{ background: 'transparent', border: '1px solid rgba(201,168,76,0.2)', color: '#A89880', padding: '0.8rem 1.5rem', fontFamily: 'Montserrat, sans-serif', fontSize: '0.65rem', letterSpacing: '0.2em', textTransform: 'uppercase', cursor: 'pointer' }}>
                Cancelar
              </button>
              <button onClick={guardarPlato} disabled={guardando} style={{ background: 'var(--gold)', border: '1px solid var(--gold)', color: '#0E0C0A', padding: '0.8rem 1.5rem', fontFamily: 'Montserrat, sans-serif', fontSize: '0.65rem', letterSpacing: '0.2em', textTransform: 'uppercase', cursor: 'pointer', opacity: guardando ? 0.7 : 1 }}>
                {guardando ? 'Guardando...' : 'Guardar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
